/**
 * Код состояния HTTP (англ. HTTP status code) — часть первой строки ответа сервера при запросах по протоколу HTTP.
 */
export enum HttpStatusCode {
  /**
   * Код ответа "HTTP 100 Continue" на информационный статус указывает, что все до сих пор в порядке и что клиент должен продолжить запрос или игнорировать его, если он уже завершён
   */
  CONTINUE = 100,

  /**
   * Код ответа протокола HTTP 101 Switching Protocol указывает протокол, который сервер переключает, используя клиентский запрос Upgrade
   */
  SWITCHING_PROTOCOLS = 101,

  /**
   * Запрос принят, но на его обработку понадобится длительное время. Используется сервером, чтобы клиент не разорвал соединение из-за превышения времени ожидания
   */
  PROCESSING = 102,

  /**
   * HTTP код 103 Early Hints в первую очередь предназначен для использования с заголовком Link, чтобы клиент мог начать предварительную загрузку пока сервер готовит ответ
   */
  EARLYHINTS = 103,

  /**
   * Код ответа об успешном статусе "The HTTP 200 OK" указывает, что запрос выполнен успешно
   */
  OK = 200,

  /**
   * HTTP 201 Created Код ответа об успешном статусе указывает, что запрос выполнен успешно и привёл к созданию ресурса. Новый ресурс эффективно создаётся до отправки этого ответа. И новый ресурс возвращается в теле сообщения, его местоположение представляет собой либо URL-адрес запроса, либо содержимое заголовка Location
   */
  CREATED = 201,

  /**
   * Код состояния ответа 202 Accepted указывает, что запрос получен, но ещё не обработан. Это не является обязательным, что означает, что в HTTP невозможно передать более поздний асинхронный ответ, указывающий на результат обработки запроса. Он предназначен для случаев, когда другой процесс или сервер обрабатывает запрос или для пакетной обработки
   */
  ACCEPTED = 202,

  /**
   * "The HTTP 203 Non-Authoritative Information Статус ответа указывает, что запрос был успешным, но прилагаемая полезная нагрузка была изменена с учётом ответа сервера200 (OK) сервера происхождения с помощью преобразующего proxy
   */
  NON_AUTHORITATIVE_INFORMATION = 203,

  /**
   * "The HTTP 204 No Content" код ответа статуса успеха указывает, что запрос имеет успех, но что клиенту не нужно уходить со своей текущей страницы. По умолчанию ответ 204 кешируется. В такой ответ включён ETag
   */
  NO_CONTENT = 204,

  /**
   * Статус ответа HTTP 205 Reset Content сообщает клиенту об изменении вида документа, например, для очистки содержимого формы, сброса состояния холста или обновления пользовательского интерфейса
   */
  RESET_CONTENT = 205,

  /**
   * "The HTTP 206 Partial Content" код ответа на статус успешного указывает, что запрос преуспел, и тело содержит запрошенные диапазоны данных, как описано в Range запроса
   */
  PARTIAL_CONTENT = 206,

  /**
   * Код ответа на перенаправление "The HTTP 300 Multiple Choices" указывает, что запрос имеет несколько возможных ответов. Пользователь-агент или пользователь должны выбрать один из них. Поскольку стандартного способа выбора одного из ответов нет, этот код ответа очень редко используется.
   */
  AMBIGUOUS = 300,

  /**
   * Код перенаправления 301 Moved Permanently протокола передачи гипертекста (HTTP) показывает, что запрошенный ресурс был окончательно перемещён в URL, указанный в заголовке Location. Браузер в случае такого ответа перенаправляется на эту страницу, а поисковые системы обновляют свои ссылки на ресурс (говоря языком SEO, вес страницы переносится на новый URL-адрес).
   */
  MOVED_PERMANENTLY = 301,

  /**
   * HTTP код перенаправления 302 Found означает, что запрошенный ресурс был временно перемещён по адресу, указанному в заголовке Location. Получив такой ответ браузер перенаправляется на новую страницу, но поисковые системы не обновляют свои ссылки на ресурс (в жаргоне SEO говорят, что вес ссылки (link-juice) не меняется и не отправляется на новый URL-адрес).
   */
  FOUND = 302,

  /**
   * HTTP код перенаправления 303 See Other обычно отправляется в результате PUT или POST запроса и указывает, что перенаправление производится не на новый (только что загруженный) ресурс, а на другую страницу, например, страницу подтверждения или страницу с результатами загрузки. Метод, используемый для отображения страницы, на которую производится перенаправление - всегда GET.
   */
  SEE_OTHER = 303,

  /**
   * Код "HTTP 304 Not Modified" клиента указывает, что нет необходимости повторно передавать запрошенные ресурсы. Это неявное перенаправление на кешированный ресурс. Это происходит, когда метод safe, например GET или HEAD запрос или когда запрос является условным и использует If-None-Match или If-Modified-Since.
   */
  NOT_MODIFIED = 304,

  /**
   * HTTP код перенаправления 307 Temporary Redirect означает, что запрошенный ресурс был временно перемещён в URL-адрес, указанный в заголовке Location.
   */
  TEMPORARY_REDIRECT = 307,

  /**
   * Код ответа HTTP 308 Permanent Redirect" указывает, что запрошенный ресурс был окончательно перемещён на URL-адрес, указанный в заголовке Location. Браузер перенаправляется на эту страницу, а поисковые системы обновляют свои ссылки на ресурс (говоря языком SEO, «link-juice льётся на новый URL-адрес»).
   */
  PERMANENT_REDIRECT = 308,

  /**
   * Код состояния ответа "HTTP 400 Bad Request" указывает, что сервер не смог понять запрос из-за недействительного синтаксиса. Клиент не должен повторять этот запрос без изменений.
   */
  BAD_REQUEST = 400,

  /**
   * Код ответа на статус ошибки HTTP 401 Unauthorized клиента указывает, что запрос не был применён, поскольку ему не хватает действительных учётных данных для целевого ресурса.
   */
  UNAUTHORIZED = 401,

  /**
   * HTTP-ответ 402 Payment Required это нестандартная ошибка клиента, зарезервированная для использования в будущем.
   */
  PAYMENT_REQUIRED = 402,

  /**
   * Код ответа на статус ошибки "HTTP 403 Forbidden" указывает, что сервер понял запрос, но отказывается его авторизовать.
   */
  FORBIDDEN = 403,

  /**
   * Код ответа на ошибку HTTP 404 Not Found указывает, что сервер не может найти запрошенный ресурс. Ссылки, ведущие к коду 404, часто называются сломанными или мёртвыми связями и приводят к ссылочной гнили.
   */
  NOT_FOUND = 404,

  /**
   * Код состояния протокола HTTP 405 Method Not Allowed, указывает, что метод запроса известен серверу, но был отключён и не может быть использован. Два обязательных метода GET и HEAD никогда не должны быть отключены и не должны возвращать этот код ошибки.
   */
  METHOD_NOT_ALLOWED = 405,

  /**
   * HyperText Transfer Protocol (HTTP) код ошибки клиента 406 Not Acceptable означает, что сервер не может вернуть ответ, соответствующий списку допустимых значений, определённых в заголовках упреждающего согласования контента, и что сервер не желает вернуть представление контента по умолчанию.
   */
  NOT_ACCEPTABLE = 406,

  /**
   * HTTP 407 Proxy Authentication Required код ответа на ошибку клиента указывает, что запрос не был применён, поскольку он не имеет достоверных учётных данных для proxy server, который находится между браузером и сервером, который может получить доступ к запрашиваемому ресурсу.
   */
  PROXY_AUTHENTICATION_REQUIRED = 407,

  /**
   * HTTP 408 Request Timeout означает, что сервер хотел бы отключить это неиспользуемое соединение. Он отправляется на незанятое соединение некоторыми серверами, даже без какого-либо предыдущего запроса клиентом
   */
  REQUEST_TIMEOUT = 408,

  /**
   * HTTP 409 Conflict код состояния ответа указывает на конфликт запроса с текущим состоянием сервера.
   */
  CONFLICT = 409,

  /**
   * Код ошибки HTTP 410 Gone указывает, что целевой ресурс больше недоступен на сервере происхождения и что это состояние, вероятно, будет постоянным.
   */
  GONE = 410,

  /**
   * Код ответа на ошибку 411 Length Required указывает, что сервер отказывается принять запрос без определённого Content-Length.
   */
  LENGTH_REQUIRED = 411,

  /**
   * The HTTP 412 Precondition Failed клиентский код ответа на ошибку указывает, что доступ к целевому ресурсу был отклонён. Это происходит с условными запросами на методы, отличные от GET или HEAD, когда условие определено If-Unmodified-Since или {HTTPHeader("If-None-Match")}} не выполняется. В этом случае запрос, обычно загрузка или изменение ресурса, не может быть выполнен, и этот ответ об ошибке отправляется обратно.
   */
  PRECONDITION_FAILED = 412,

  /**
   * Код HTTP 413 Payload Too Large , указывает, что объект запроса больше, чем ограничения, определённые сервером; сервер может закрыть соединение или вернуть поле Retry-After.
   */
  PAYLOAD_TOO_LARGE = 413,

  /**
   * Код состояния HTTP 414 URI Too Long указывает, что URI, запрошенный клиентом, длиннее, чем сервер готов интерпретировать.
   */
  URI_TOO_LONG = 414,

  /**
   * Код ответа на ошибку клиента HTTP 415 Unsupported Media Type указывает, что сервер отказывается принять запрос, потому что формат содержимого не поддерживается сервером.
   */
  UNSUPPORTED_MEDIA_TYPE = 415,

  /**
   * Код ошибки HTTP 416 Range Not Satisfiable указывает, что сервер не может обслуживать запрошенные диапазоны. Наиболее вероятная причина заключается в том, что документ не содержит таких диапазонов или что значение Range, хотя и синтаксически корректно, не имеет смысла.
   */
  REQUESTED_RANGE_NOT_SATISFIABLE = 416,

  /**
   * Код ошибки HTTP 417 Expectation Failed указывает на то, что ожидание, указанное в Expect, не может быть выполнено.
   */
  EXPECTATION_FAILED = 417,

  /**
   * HTTP код ошибки 418 I'm a teapot сообщает о том, что сервер не может приготовить кофе, потому что он чайник. Эта ошибка ссылается на Hyper Text Coffee Pot Control Protocol (гипертекстовый протокол кофейников) который был первоапрельской шуткой в 1998 году.
   */
  I_AM_A_TEAPOT = 418,

  /**
   * Запрос был перенаправлен на сервер, не способный дать ответ.
   */
  MISDIRECTED = 421,

  /**
   * Код состояния ответа HTTP 422 Unprocessable Entity указывает, что сервер понимает тип содержимого в теле запроса и синтаксис запроса является правильным, но серверу не удалось обработать инструкции содержимого.
   */
  UNPROCESSABLE_ENTITY = 422,

  /**
   * реализация текущего запроса может зависеть от успешности выполнения другой операции. Если она не выполнена и из-за этого нельзя выполнить текущий запрос, то сервер вернёт этот код.
   */
  FAILED_DEPENDENCY = 424,

  /**
   * Код статуса HTTP 428 Precondition Required означает, что сервер требует, чтобы запрос был условным (соответствовал неким предварительно заданным условиям).
   */
  PRECONDITION_REQUIRED = 428,

  /**
   * HTTP 429 Too Many Requests код ответа указывает, что пользователь отправил слишком много запросов за последнее время ("ограничение скорости" или "rate limiting" ).
   */
  TOO_MANY_REQUESTS = 429,

  /**
   * Код ответа сервера 500 Internal Server Error указывает на то, что сервер столкнулся с неожиданной ошибкой, которая помешала ему выполнить запрос.
   */
  INTERNAL_SERVER_ERROR = 500,

  /**
   * The HTTP 501 Not Implemented серверный код ответа на ошибку указывает, что метод запроса не поддерживается сервером и не может быть обработан. Единственными методами, которые необходимы серверам для поддержки (и, следовательно, не должны возвращать этот код), являются GET и HEAD.
   */
  NOT_IMPLEMENTED = 501,

  /**
   * HTTP серверный код ответа на ошибку 502 Bad Gateway указывает, что сервер, действуя как шлюз или прокси, получил неверный ответ от восходящего сервера.
   */
  BAD_GATEWAY = 502,

  /**
   * HTTP 503 Service Unavailable код состояния сервера, указывающий на то, что сервер не готов обработать данный запрос.
   */
  SERVICE_UNAVAILABLE = 503,

  /**
   * HTTP код 504 Gateway Timeout , полученный в ответе, указывает на ошибку, что сервер, действуя как шлюз или прокси, не может получить ответ вовремя.
   */
  GATEWAY_TIMEOUT = 504,

  /**
   * HTTP 505 HTTP Version Not Supported код состояния ответа указывает, что версия HTTP, используемая в запросе, не поддерживается сервером.
   */
  HTTP_VERSION_NOT_SUPPORTED = 505,

  /**
   * The HTTP 511 Network Authentication Required код состояния ответа указывает, что клиент должен пройти аутентификацию, чтобы получить доступ к сети.
   */
  NETWORK_AUTHENTICATION_REQUIRED = 511,
}
